import { useShaRouting } from '@shesha-io/reactjs';
import { isSameUrls } from "@shesha-io/reactjs";

export interface UseLoginUrlArgs {
  homePageUrl: string;
  unauthorizedRedirectUrl: string;
}

export const useLoginUrl = ({ homePageUrl, unauthorizedRedirectUrl }: UseLoginUrlArgs) => {
  const { router } = useShaRouting();

  const redirectUrl =
    isSameUrls(router?.path, homePageUrl) || isSameUrls(router?.path, unauthorizedRedirectUrl)
      ? ''
      : `/?returnUrl=${encodeURIComponent(router?.fullPath)}`;

  return `${unauthorizedRedirectUrl}${redirectUrl}`;
};
